import { render } from "./AddGroupUserModal.vue?vue&type=template&id=0534b65a&scoped=true"
import script from "./AddGroupUserModal.vue?vue&type=script&lang=js"
export * from "./AddGroupUserModal.vue?vue&type=script&lang=js"

import "./AddGroupUserModal.vue?vue&type=style&index=0&id=0534b65a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0534b65a"]])

export default __exports__